<template>
    <guest-layout>
        <div class="form-col mh-100">
            <div class="arrow-back d-none d-lg-block">
                <a :href="route('login')"><span><i class="feather-chevron-left"></i></span>Back to login</a>
            </div>
            <div class="web-form step-form">
                <div class="title-col regTitle">
                    <h2>Create an Account</h2>
                    <p>Type in your details to sign up. Once you sign up you start with a free plan.</p>
                </div>
                <form class="form-style" @submit.prevent="submit">
                    <div class="form-group reg-form-group">
                        <label class="label-style" for="nameId">Name</label>
                        <div class="input-col">
                            <input type="text" class="form-control input-style" placeholder="Type here" id="name" v-model="form.name"  autofocus autocomplete="name">
                            <div v-if="form.errors.name" v-bind:style="styleObject">{{ form.errors.name }}</div>
                        </div>
                    </div>
<!--                    <div class="form-group reg-form-group">-->
<!--                        <label class="label-style" for="userName">Username</label>-->
<!--                        <div class="input-col space-input">-->
<!--                            <input type="text" class="form-control input-style" placeholder="Type here" id="username" v-model="form.username" autocomplete="username">-->
<!--                            <div v-if="form.errors.username" v-bind:style="styleObject">{{ form.errors.username }}</div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="form-group reg-form-group">
                        <label for="emailFld" class="label-style">Email address*</label>
                        <div class="input-col">
                            <input type="text" name="email" class="form-control input-style" id="email" v-model="form.email" required>
                            <div v-if="form.errors.email" v-bind:style="styleObject">{{ form.errors.email }}</div>
                        </div>
                    </div>
                    <div class="form-group reg-form-group">
                        <label class="label-style" for="pwdFld">Password*</label>
                        <div class="input-col space-input">
                            <input v-bind:type="[showPassword ? 'text' : 'password']" id="password" type="password" class="form-control input-style" name="password" v-model="form.password" required autocomplete="new-password">
                            <button type="button" class="show-hide-class" @click="showPassword = !showPassword">show</button>
                            <div v-if="form.errors.password" v-bind:style="styleObject">{{ form.errors.password }}</div>
                        </div>
                    </div>
                    <div class="form-group reg-form-group">
                        <label class="label-style" for="pwdFld">Confirm Password*</label>
                        <div class="input-col space-input">
                            <input v-bind:type="[confirm_showPassword ? 'text' : 'password']" id="password_confirmation" type="password" class="form-control input-style" v-model="form.password_confirmation" required autocomplete="new-password">
                            <button type="button" class="show-hide-class" @click="confirm_showPassword = !confirm_showPassword">show</button>
                        </div>
                    </div>
                    <div class="form-group reg-form-group">
                        <div class="terms-and-conditions">
                            <div class="custom-control custom-checkbox check-box-style">
                                <input type="checkbox" class="form-check-input" name="terms" id="terms" v-model="form.terms" >
                                <label class="custom-control-label" for="terms">
                                    I agree <span>to</span> the <a href="https://helmbay.com/terms-of-service" target="_blank">Terms of Service</a>
                                    and <a href="https://helmbay.com/privacy-policy" target="_blank">Privacy Policy</a>
                                </label>
                                <div v-if="form.errors.terms" v-bind:style="styleObject">{{ form.errors.terms }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group reg-form-group">
                        <button type="submit" class="btn btn-style btn-primary w-100" :disabled="form.processing">
                            <span>Register</span>
                        </button>
                    </div>
                    <div class="form-group reg-form-group">
                        <div class="login-content text-center">
                            <!-- <span>Already have an account? <a href="login-first-step.html">Login</a></span> -->
                            Already have an account?
                            <inertia-link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                Login here
                            </inertia-link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </guest-layout>
</template>
<script>
    import GuestLayout from "@/Layouts/GuestLayout";
        export default {
            props: {
                errors: Object,
            },

            components: {
                GuestLayout,
            },

            data() {
                return {
                    form: this.$inertia.form({
                        name: '',
                        username: '',
                        email: '',
                        password: '',
                        password_confirmation: '',
                        terms: false,
                    }),
                    styleObject: {
                        color: 'red',
                        fontSize: '15px'
                    },
                    showPassword: false,
                    confirm_showPassword:false,
                }
            },

            methods: {
                submit() {
                    this.form.post(this.route('register'), {
                        onFinish: () => this.form.reset('password', 'password_confirmation'),
                    })
                }
            }
        }
</script>
